'use client';

import type { FC } from 'react';
import { NO_TARIFFS_ERROR_CAUSE } from '@/constants';
import { GasCard } from '../card/gas-card';
import { useGasTariffs } from '../tariffs-providers/use-gas-tariffs';

type GasCardsProps = {
  formAction: (state: undefined, formData: FormData) => Promise<undefined>;
  isComboCheckout: boolean;
};

export const GasCards: FC<GasCardsProps> = ({ formAction, isComboCheckout }) => {
  const { tariffs } = useGasTariffs() || {};

  if (!tariffs?.length) {
    throw new Error('No tariffs available', { cause: NO_TARIFFS_ERROR_CAUSE });
  }

  return (
    <>
      {tariffs.map((item, index) => (
        <GasCard
          cardIndex={index}
          initialActiveIndex={0}
          isComboCheckout={isComboCheckout}
          key={item[0].productCode}
          products={item}
          selectAction={formAction}
          tariffsCount={tariffs.length}
        />
      ))}
    </>
  );
};
